<footer rds-footer class="compact-footer">
  <rds-footer-disclaimer>
    <div class="footer-row">
      <div class="copyright">
        <rds-footer-caption>© 2026 F. Hoffmann-La Roche Ltd</rds-footer-caption>
      </div>
      <div class="team-info">
        <rds-footer-caption>
          <strong>Planwise Development Team:</strong>
          <a href="mailto:daniela.wach@roche.com">Daniela Wach</a> (Product Owner),
          <a href="mailto:berk_adrian.greser@roche.com">Berk Adrian Greser</a> (Developer),
          <a href="mailto:piotr.was@roche.com">Piotr Was</a> (Developer),
          <a href="mailto:sebastian.hein@roche.com">Sebastian Hein</a> (Product Manager)
        </rds-footer-caption>
      </div>
    </div>
  </rds-footer-disclaimer>
</footer>
